// extracted by mini-css-extract-plugin
export default {"keyboard":"Keyboard_keyboard__CDQQS","key":"Keyboard_key__9lANI"};